const useChangeFontSize = (domId) => {
    const changFontSize = (fontSize) => {
        let _el = document.getElementById(domId)
        if (_el) {
            // 新闻的时候
            if (domId === 'bodyContent') {
                let _dict = {
                    20: 'big',
                    18:'middle',
                    16:'small',
                }
                _el.classList = []
                _el.classList.add(_dict[fontSize])
            } else {
                _el.style.fontSize=`${fontSize}px`
            }
        } else {
            throw new Error("domId 不存在")
        }
    }
    return {changFontSize}
}
export default useChangeFontSize